export default "__VITE_ASSET__COgo$198__"